var React = require('react');

function TransparentFilled04Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"white","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M13.6 25H10.2V14.3H13.6V25ZM11.9 12.8C10.8 12.8 10 12 10 10.9C10 9.8 10.9 9 11.9 9C13 9 13.8 9.8 13.8 10.9C13.8 12 13 12.8 11.9 12.8ZM26 25H22.6V19.2C22.6 17.5 21.9 17 20.9 17C19.9 17 18.9 17.8 18.9 19.3V25H15.5V14.3H18.7V15.8C19 15.1 20.2 14 21.9 14C23.8 14 25.8 15.1 25.8 18.4V25H26Z","stroke":"white","key":1})]);
}

TransparentFilled04Inline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = TransparentFilled04Inline;

TransparentFilled04Inline.default = TransparentFilled04Inline;
